export default __webpack_public_path__ + "static/media/home_1.27474e8a.svg";